'use strict';

/**
 * @name Novicell Validate
 * @desc A script that inits validate.js with default Novicell settings
 * @author Bjørn Nyborg (BNY)
 * @example <form data-validate>
 * @requires https://github.com/cferdinandi/validate
 */


var novicell = novicell || {};  

novicell.validate = novicell.validate || new function () {

    this.init = function () {
        var standardMessageValueMissing = 'Please fill out this field.';
        validate.init({
            // Classes and Selectors
            selector: '[data-validate]',
            fieldClass: 'error',
            errorClass: 'error-message',

            // Messages
            messageValueMissing: standardMessageValueMissing,
            messageValueMissingRadio: 'Please select a payment method.', // Displayed when a required radio button isn't selected
            messageValueMissingSelect: 'Please select a value.',
            messageValueMissingSelectMulti: 'Vælg venligst mindst én værdi',
            messageTypeMismatchEmail: 'Please enter a valid email address.',
            messageTypeMismatchURL: 'Indtast en gyldig URL',
            messageTooShort: 'Indtast venligst {minLength} karakterer eller mere. Du har indtastet {length} karakterer.',
            messageTooLong: 'Indtast venligst {maxLength} eller færre karakterer. Du har indtastet {length} karakterer.',
            messagePatternMismatch: 'Du har indtastet data i et forkert format',
            messageBadInput: 'Indtast venligst et tal',
            messageStepMismatch: 'Vælg venligst en gyldig værdi',
            messageRangeOverflow: 'Du må ikke angive mere end {max}.',
            messageRangeUnderflow: 'Du må ikke angive mindre end {min}.',
            messageGeneric: 'Den indtastede værdi er ugyldig',

            // Form Submission
            disableSubmit: false,
            onSubmit: function () {},

            // Callbacks
            beforeShowError: function (e) {
                e.classList.add("validated");
            },
            afterShowError: function (field, error) {
                if(field.id == 'termsConditions'){
                    if(error == "This field is required."){
                        var customMessage = field.getAttribute('title');
                        validate.showError(
                            field, // The field to show an error message for
                            customMessage// The error message to show
                        ); 
                    }
                }
            },
            beforeRemoveError: function () { },
            afterRemoveError: function () { },

        });
    };
}();